// extracted by mini-css-extract-plugin
module.exports = {"tab":"index_tab__3c08R","tab__item":"index_tab__item__3pOez","tab__item--active":"index_tab__item--active__3GbtL","tab__item--margin":"index_tab__item--margin__1ZX56"};